import React, { useEffect, useState } from 'react'
import classes from "../../styles.module.css";
import { useNavigate } from 'react-router-dom';
import TitleSection from '../../../../common/TitleSection';
import { Helmet } from 'react-helmet';
import { FullWidthWiraaAds } from '../../../../common/Ads/FullWidthWiraaAds';
import styles from "../../../../ContentStyling.module.css";

const FeettoInches = () => {
    const [inputValue, setInputValue] = useState();
    const [outputValue, setOutputValue] = useState();
    const [errorMessage, setErrorMessage] = useState();
    const navigate = useNavigate();

    useEffect(() => {
        // Initialize Google Ads
        try {
          (window.adsbygoogle = window.adsbygoogle || []).push({});
          console.error("AdSense run successfully");
        } catch (e) {
          console.error("AdSense error", e);
        }
      }, []);

      const convertFeetToInches = () => {
        // Validate input: allow numbers, decimals, and optional minus sign
        if (!/^-?\d+(\.\d+)?$/.test(inputValue)) {
            setErrorMessage("Please enter a valid length in feet (e.g., 5, 6.5).");
            setOutputValue("");
            return;
        }

        setErrorMessage("");
        const feetValue = parseFloat(inputValue); // Convert input string to a number
        const inchesValue = feetValue * 12; // 1 foot = 12 inches
        setOutputValue(inchesValue.toFixed(6)); // Limit output to 6 decimal places
    };





      const handleClearBtn = () => {
        setInputValue("");
        setOutputValue("");
        setErrorMessage("");
      }

      const handleSwapClick = () => {
        navigate("/converters/inches-to-feet");
    };

        

  return (
    <div className={classes.page}>
      <Helmet>
                <title>Feet to Inches Converter - Wiraa tools</title>
                <meta name="description" content="Easily convert feet to Inches using our online conversion tool. Accurate results with simple calculations for your length measurements. Try now!" />
        </Helmet>
    <div className={classes.container}>
      <TitleSection
                    icon="https://cdn-icons-png.flaticon.com/128/570/570968.png"
                    title="Feet To Inches Converter"
                    subTitle="Effortlessly Convert Feet To Inches for Accurate Measurements"
                  />
      <div className={classes.innerCon}>
        <div className={classes.inputCon}>
            <p className={classes.inputplaceholder}>Feet Value</p>
            <input value={inputValue} onChange={(e) => setInputValue(e.target.value)} className={classes.inputfield} placeholder='Enter feet value'/>
            {errorMessage && <p className={classes.errorMsg}>{errorMessage}</p>}
        </div>
        <div className={classes.btnCon}>
            <button className={classes.convertBtn} onClick={convertFeetToInches}>Convert</button>
            <button className={classes.clearBtn} onClick={handleClearBtn}>Clear</button>
            <button className={classes.swapBtn} onClick={handleSwapClick}>Swap</button>
        </div>
        <div className={classes.outputCon}>
            <p className={classes.outputplaceholder}>Inches Value</p>
            <p className={classes.outputfield}>{outputValue}</p>
        </div>
      </div>
      <div className={classes.ads}>
        <FullWidthWiraaAds/>
     </div>
     <div className={styles.contentContainer}>
      <p>For designers, architects, DIY enthusiasts, and anyone working with physical dimensions, the Feet to Inches Converter is a must-have tool. It lets you convert values from feet (ft) to inches (in) a critical conversion for construction, interior design, and even measuring personal height.</p>
      <p>This converter ensures your measurements are accurate and compatible with imperial system standards, especially in the U.S. and U.K.</p>
      <h3>What Are Feet and Inches?</h3>
      <p><b>Feet (ft): </b>A unit of length in the imperial system. It is commonly used in everyday measurements like height, room dimensions, and wood lengths. <br />1 foot = 12 inches</p>
      <p><b>Inches (in): </b> A smaller imperial unit used for finer measurements in objects, tools, and specs. <br />1 inch = 1/12 foot</p>
      <h3>Why Convert Feet to Inches?</h3>
      <ul>
        <li><b>Design & Construction:</b> Blueprints and material specs often use inches for accuracy.</li>
        <li><b>Detailed Measurement:</b> Inches provide more precise measurement values.</li>
        <li><b>Standardization:</b> Ensures consistency across imperial unit projects.</li>
      </ul>
      <h3>How to Use the Feet to Inches Converter</h3>
      <ol>
        <li><b>Input Feet Value:</b> Enter the number of feet into the field.</li>
        <li><b>Click Convert:</b> The tool will automatically calculate the equivalent inches.</li>
        <li><b>Use the Inches:</b> Apply the converted value in your design, blueprint, or order.</li>
      </ol>
      <h3>Conversion Examples:</h3>
      <ul>
        <li>1 ft → 12 in</li>
        <li>2.5 ft → 30 in</li>
        <li>5 ft → 60 in</li>
        <li>6.2 ft → 74.4 in</li>
      </ul>
      <h3>Benefits of Using Feet to Inches Converter</h3>
      <ul>
        <li><b>Ease of Use:</b> Simple interface enter, click, done.</li>
        <li><b>Accuracy:</b> Eliminates manual math errors.</li>
        <li><b>Time-Saving:</b> Fast and reliable for all types of users.</li>
      </ul>
      <h3>Why Choose the Feet to Inches Converter?</h3>
      <p>This tool is designed for professionals and everyday users who need quick, precise conversions. It’s ideal for:</p>
      <ul>
        <li><b>Carpenters & Builders:</b> To measure and cut with confidence.</li>
        <li><b>Interior Designers:</b> To plan layouts and furniture fitting.</li>
        <li><b>Students & Teachers:</b> To learn and teach unit conversions effectively.</li>
      </ul>
     </div>
    </div>
   </div>
  )
}

export default FeettoInches;
